import { render } from "./DetailBill.vue?vue&type=template&id=274d1a77"
import script from "./DetailBill.vue?vue&type=script&lang=js"
export * from "./DetailBill.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__